<template>
  <v-select
    :id="id"
    :options="options"
    :class="selectClass"
    :placeholder="placeholder"
    :label="selectLabel"
    :value="value"
    @search="onSearch"
    :filterable="false"
    @input="(item) => $emit('input', item)"
    autocomplete="new-password"
  >
    <template #option="option">
      <div>{{ option.description }}</div>
      <div class="font-size-sm text-secondary">
        {{ option.quote_template?.name || option.template_name }}
      </div>
    </template>
    <template #no-options="{ search, searching }">
      <template v-if="searching">
        No results found for
        <em>{{ search }}</em>
      </template>
      <em
        style="opacity: 0.7"
        v-else
      >Type to search by template or description</em>
    </template>
  </v-select>
</template>

<script>
import { debounce as _debounce } from 'lodash';

export default {
  name: 'QuoteTemplateItemsSelect',
  props: {
    value: Object,
    id: {
      type: String,
      default: 'quote-template-item',
    },
    selectLabel: {
      type: String,
      default: 'description',
    },
    selectClass: {
      type: Object,
      default: () => new Object(),
    },
    filterParams: {
      type: Object,
      default: () => new Object(),
    },
    placeholder: String,
  },
  data() {
    return {
      options: [],
    };
  },
  methods: {
    onSearch(text, loading) {
      if (text.length) {
        loading(true);
        this.filterItems(text, loading, this);
      }
    },
    filterItems: _debounce((text, loading, vm) => {
      const params = {
        ...vm.filterParams,
        text: text,
      };
      vm.$quoteTemplatesAPI.getTemplateItems(params).then((response) => {
        vm.options = response.quoteTemplateItems;
        loading(false);
      });
    }, 500),
  },
};
</script>
